import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-foreground-950 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col items-center md:items-start gap-10 md:gap-12">
          {/* Brand */}
          <div className="text-center md:text-left">
            <Link to="/" className="inline-block cursor-pointer">
              <img
                src="https://storage.helloreaddy.io/project_files/051d548c-4efa-4d12-87d7-897fd5389524/29249a17-99af-42bb-85f6-269475963b62_compressed_6b390e2f-f962-4d91-a1f1-dbfc689ca9f9.webp"
                alt="Erika López Castañeda – Mentoría y Reflexión Estratégica"
                className="h-[90px] sm:h-[110px] md:h-[130px] w-auto object-contain brightness-0 invert"
              />
            </Link>
            <p className="mt-2 text-sm text-foreground-400 tracking-[0.03em]">
              Mentora de Reflexión Estratégica
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center md:justify-start items-center gap-x-6 gap-y-3">
            <Link to="/sobre-mi" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Sobre mí
            </Link>
            <Link to="/servicios" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Servicios
            </Link>
            <Link to="/como-lo-hago" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Método CALMA
            </Link>
            <Link to="/blog" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Blog
            </Link>
            <Link to="/contacto" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">
              Contacto
            </Link>
            <a
              href="mailto:celc.erika@outlook.com"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              Correo
            </a>
            <a
              href="https://wa.me/526646121065"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              WhatsApp
            </a>
            <a
              href="#"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
            >
              Instagram
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center md:text-left w-full md:w-auto">
            <p className="text-xs text-foreground-500 tracking-[0.03em]">
              &copy; {currentYear} Erika López Castañeda. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}